import { VALID_RECEIPT_MIMETYPES } from '@/utils/constants'
export default {
  data () {
    return {
      isDragging: false,
      fileUploadByDrop: false,
      receiptCount: 0
    }
  },
  methods: {
    onDragenter (event) {
      event.preventDefault()
      this.isDragging = true
    },
    onDragover (event) {
      event.preventDefault()
      this.receiptCount = 0
      this.isDragging = true
    },
    onDragleave (event) {
      event.preventDefault()
      this.isDragging = false
      this.reset()
    },
    async ondrop (event) {
      event.preventDefault()
      if (this.transactionIsLocked) {
        this.$store.dispatch('SnackBars/addError', this.$i18n.t('transaction_is_locked_error'))
        this.reset()
        return
      }
      const files = [...event.dataTransfer.files]
      const invalidFiles = files.filter(el => !VALID_RECEIPT_MIMETYPES.includes(el.type))

      if (invalidFiles.length > 0) {
        this.$store.dispatch('SnackBars/addError', this.$i18n.t('transaction_upload_receipt_invalid_mimetype'))
        this.reset()
        return
      }
      this.receiptCount = files.length
      this.fileUploadByDrop = true
      this.manageReceipts(event.dataTransfer.files)
      this.fileUploadByDrop = false
      this.isDragging = false
      this.reset()
      // Fetch after everything is completed
    },
    manageReceipts (event) {
      this.$emit('showReceiptMediaTypeModal', event)
    },

    reset () {
      this.receiptCount = 0
      this.isDragging = false
    }

  }
}
